import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WebinarPage from "../pages/webinar/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/webinar",
    element: <WebinarPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
